export default __webpack_public_path__ + "static/media/anaconda.e94528b4.png";